import { getLink } from "../../../utils/utils";

const content = {
	esp: (
		`
		<p class="mb-3">
			Estimataj gesamideanoj!
		</p>
		
		<p class="mb-3">
			Antaŭ kelkaj tagoj en nia dissendolisto aperis dua mesaĝo de Jefim Zajdman, kvazaŭ voĉo en dezerto vokanta. 
			Li proponas sobrajn aferojn, sed ĉu aŭskultas lin iu? 
			Entute, sur la tereno ni vidas 2-4 personojn, skribantajn konstante, eĉ ofte po kelkfoje tage; sed ĉu ne ŝajnas, ke ili aŭskultas nur sin mem? 
			Kaj kion faras, pensas, proponas aliuj centoj da e-istoj el 17 provincoj de Ukrainio (laŭ informo de Jarlibro de UkrEA 2004-2005; poste, kiel mi scias, la Jarlibro ne estis eldonata). 
			Konferenco en Lucko, agadoj en Kievo, en Poltavo, en Krimeo… 
			Kaj kio en aliuj regionoj de nia grandega lando? 
			Ĉu morna kaj morta silento?
		</p>
		
		<p class="mb-3">
			Oni povas paroli pri la Asocia krizo. 
			Sed kiu agas: ĉu Asocio mem aŭ ĝiaj membroj? 
			Ĉu Asocio povas ordoni al siaj membroj kaj ĉu ili obeos, se ilin ne interesas la proponita agado? 
			Fakte, neniu Asocio, eĉ UEA, havas rajton kaj eblon postuli ion de siaj membroj, ĝi povas nur proponi, krei planojn, kaj la membraro mem decidas, ĉu fari ion aŭ ne.
		</p>
		
		<p class="mb-5">
			Aliflanke, Esperanto ekzistas tie, kie estas esperantistoj. 
			En kelkaj provincoj de Ukrainio ne ekzistas eĉ apartaj e-istoj, kaj kiel ajn Estraro kaj Prezidio de UkrEA deziregu, ke tie floru aŭ almenaŭ ĝermu nia lingvo, tio ne okazos, se realaj personoj ne ekagos tie. 
			Gravas nur agoj, ne vortoj; kaj agi eblas por ĉiu persono aŭ klubo nur sur sia propra tereno: sia urbo, provinco, vilaĝo, kie estas konataj kondiĉoj, ekzistas privataj ligoj kun iuj influaj sur diversaj kampoj personoj, fin-fine, aŭtoritato kaj publika estimo, akiritaj pro antaŭaj agadoj, kaj do eblecoj vere fruktodone «fosi sian sulkon». 
			Mi parolas surbaze de mia propra sperto: kelkfoje mi estis vic-prezidanto de Ukrainia Esperanto-Asocio, sed ĉio, kion mi faris por Eo: organizo de tri Lingvaj Festivaloj, de regionaj renkontiĝoj «Aprilaj Ridetoj» kaj «Zamenhofaj Tagoj», de tri naturprotektaj Ekspedicioj «Dnestro», filmado de du esperantlingvaj filmetoj ktp – mi faris nur en Odessa kaj surbaze de eblecoj kaj kapabloj de nia junulara Esperanto-klubo «Verdaĵo». 
			Ĉu eblus imagi, ke mi, kiel vic-prezidanto aŭ respondeca prezidiano, jen ordonu al, ekz., Poltavaj aŭ  Hmelnickaj e-istoj, ke ili organizu Lingvan Festivalon aŭ filmu E-filmojn, aŭ verku novan lernolibron? Ja ĉiu sur sia loko scias siajn eblecojn kaj kapablojn, kaj povas fari nur tion, kion permesas sperto, lokaj kondiĉoj, kaj al kio strebas la animo. 
			Ajnaj desupraj planoj restos nur paroloj, se homoj ne volas aŭ ne povas plenumi ilin.
		</p>
		
		<p class="mb-3">
			Kaj jen, post la iom tro longa prolegomeno, mia propono. 
			Ĉar evidentas, ke nia Asocio iom letargias, sed aktivaj homoj daŭre aktivas, mi proponas ekagi sur la nivelo de «herbradikoj»: ke ĉiu faru, kion povas kaj volas por prospero kaj disvastigo de Eo, kaj nia dissendolisto iĝu la raporttabulo por informoj pri plej diversaj agadoj de la kluboj kaj apartaj e-istoj. 
			Kaj por organizi tiun agadon tutlande, indas rememori la labormanieron de iama «glora SEJM» – la t.n. «socialisman konkuradon», kiu estis la kerno kaj instiga laborforto de ĝia laboro. 
			Kiun timigas la vorto «socialisma», tute povas omiti ĝin - tio ne gravas, gravas la ideo. 
			Kaj la ideo estas, ke en la ellaborita listo de ĉiuj eblaj kaj imageblaj agadoj, al ĉiu agado korespondas certa nombro da poentoj: ekz., 1 poento por artikolo en loka preso, 5 poentoj por 3-monata E-kurso, 20 poentoj por eldonita libro ktp. 
			Kiel bazo oni povas akcepti eĉ la SEJM’an tabelon, kiu certe estas konservata ĉe niaj veteranoj; kun nepra modernigo, certe, inkluzivigante, ekz., Lingvajn Festivalojn, verkadon por Ea Wikipedio, kreadon de propra ttt-ejo de la klubo ktp. 
			Ĉiu klubo aŭ individuo raportas pri sia agado, ricevas respektivajn poentojn, kaj fine de la jaro oni kalkulas la poentojn kaj anoncas la venkinton. 
			Tiu venkinto ricevas premion el monrimedoj de la Asocio (ĉu ili ekzistas?), kaj tio estos agnosko de ĝiaj agadoj kaj promocio por pliaj.
		</p>
		
		<p class="mb-3">
			Por tiu agado ne bezonatas prezidio, estraro, prezidento – nur iu sekretario, kiu notus ĉiujn raportojn kaj atribuos al ili respektivajn poentojn. 
			Ĉar ĉio okazos en dissendolisto, antaŭ ĉies okuloj, ne povos aperi ofendiĝoj aŭ miskomprenoj – ja ĉiuj vidos ĉion. 
			Do, bezonatas nur kompili la liston (per komunaj fortoj) kaj trovi komputileman kaj Interreteman personon por diligente noti kaj poenti. 
			Kaj trovi la monon por vere promocii la plej bonajn klubojn… 
			Kaj trovi deziron agi… 
	</p>
	
	`
	)
}

const itemName = {
	esp: 'Propono pri herbradika agado-2008'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp:{
		itemName: itemName.esp,
		itemContent: content.esp
	}
}

export default item;